import React from 'react';
import { connect } from 'react-redux';
import { ASSETS_FOLDER, COMPACT_LIMIT } from '../../../../constants';
import { COMPACT } from '../../../../texts';
import { TIMELINE } from '../../../../content';
import CompactEntry from './CompactEntry/CompactEntry';
import './SceneCompact.css';
import CompactBullet from './CompactBullet/CompactBullet';

const SceneCompact = props => {
  const entries = TIMELINE.map(entry => (
    <CompactEntry key={entry.pos} data={entry} />
  ));
  return (
    <div id="scene-compact">
      <img
        className="deco-compact"
        src={`${ASSETS_FOLDER}img/scene-compact/deco-top.jpg`}
        alt={COMPACT.ALT_TOP}
      />
      <div
        className="info-desktop"
        style={{
          background: `#95531f url(${`${ASSETS_FOLDER}img/scene-compact/bg-tile-info.jpg`}) repeat`,
        }}
      >
        <div>{COMPACT.INFO}</div>
        {props.height > COMPACT_LIMIT &&
          <div className="info-big">{COMPACT.INFO_BIG}</div>
        }
      </div>
      <div
        id="compact-main"
        style={{
          background: `#3a3730 url(${`${ASSETS_FOLDER}img/scene-compact/bg-tile.jpg`}) repeat`,
        }}
      >
        <div>{entries}</div>
        <div id="compact-bullets">
          <CompactBullet id={0} />
          <CompactBullet id={1} />
          <CompactBullet id={2} />
          <CompactBullet id={3} />
        </div>
      </div>
      <img
        className="deco-compact"
        src={`${ASSETS_FOLDER}img/scene-compact/deco-bottom.jpg`}
        alt={COMPACT.ALT_BTM}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  height: state.ui.height,
});

export default connect(mapStateToProps)(SceneCompact);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/SceneCompact/SceneCompact.js